export default __webpack_public_path__ + "static/media/x-logo.d74d7cef.png";